import { Message } from "../message.model";

export interface BaseZoneByHour {
  sector: string;
  sucursal: string;
  tipo_acceso: 'perimetral' | 'interna';
  fecha_periodo_anterior?: {
    fecha_inicial: string;
    fecha_final: string;
  };
}

export type BodyZoneByHour = BaseZoneByHour &
  (
    | {
        Tipo_consulta_BD: 'RANGO_DIAS';
        fecha_inicial: string;
        fecha_final: string;
        por_defecto?: string;
      }
    | {
        Tipo_consulta_BD: 'RANGO_MESES';
        mes_inicial: string;
        mes_final: string;
      }
    | {
        Tipo_consulta_BD: 'MES_ACTUAL';
        mes_actual: string;
      }
    | {
        Tipo_consulta_BD: 'MES_ANTERIOR';
        mes_anterior: string;
      }
    | {
        Tipo_consulta_BD: 'ANIO_ACTUAL';
        anio_actual: string;
      }
    | {
        Tipo_consulta_BD: 'ANIO_ANTERIOR';
        anio_anterior: string;
      }
  );

// A diferencia de /b/conteo_peatonal/acceso_por_hora, este endpoint sí envuelve
// la respuesta en un arreglo con 'column_name'
export interface ResponseZoneByHour {
  column_name: ColumnNameZoneByHour | Message;
}

export interface ColumnNameZoneByHour {
  "public data": DataZoneByHour;
}

export interface DataZoneByHour {
  anio_base: string | number;
  accesos: ZoneByHour[];
}

export interface ZoneByHour {
  acceso?:              string;
  camara?:              string;
  fechas:               HourFlowData[];
  indicador:            string;
  diferencia:           number;
  porcentaje:           string;
  total_flujo:          number;
  total_flujo_anterior: number;
}

export interface HourFlowData {
  Hora:           string;
  Flujo:          number;
  "Comparación"?: number;
}
